module.exports = __webpack_public_path__ + "img/ch15_02_小巷挡身 (1).14a67ce8.png";